import type { ReactNode } from 'react';

import {
  createGenerateClassName,
  StylesProvider,
} from '@material-ui/core/styles';

interface MuiV4StylesProviderProps {
  children: ReactNode;
}

const generateClassName = createGenerateClassName({ seed: 'mui-v4' });

export default function MuiV4StylesProvider({
  children,
}: MuiV4StylesProviderProps) {
  return (
    <StylesProvider generateClassName={generateClassName}>
      {children}
    </StylesProvider>
  );
}
